import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { TranslateService } from '@ngx-translate/core';

import { CommonService } from '../../services/common.service';

@Component({
  selector: 'mask-company-level-score',
  template: ` <span>{{ value }}</span> `,
  styles: [],
})
export class MaskCompanyRiskLevelScoreComponent implements ICellRendererAngularComp {
  value: string;

  constructor(private cService: CommonService, private translate: TranslateService) {}

  agInit(params: { value: any }) {
    const companyRiskLevelValues = this.cService.userProfile.companyRiskLevelValues;

    this.translate.get('REPORTDATA').subscribe({
      next: (translation: any) => {
        if (!isNaN(params.value) && companyRiskLevelValues) {
          const numberFormatted = this.cService.numberToDecimalPlace(params.value);
          this.value = ` ${numberFormatted}`;
        } else {
          this.value = translation.na;
        }
      },
    });
  }

  refresh() {
    return false;
  }
}
